import React from 'react';
import {
  makeStyles,
  Card,
  Typography,
  Grid,
  Box,
} from '@material-ui/core/';
import ContactForm from './ContactFormComponent';
import ContactUs from './ContactUsComponent';
import IFrame from './iFrameComponent';

const useStyles = makeStyles(() => ({
  root: {
    width: '80vw',
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: '-5%',
    marginBottom: '5%',
  },
  pad: {
    padding: 30,
  },
  iFrame: {
    width: '80%',
    height: '80%',
  },
  contactForm: {
    maxWidth: '550px',
    padding: '10px',
    margin: '2%',
  },
  marBot: {
    marginBottom: '10px',
  }
}));

function DateCalendar() {
  const classes = useStyles();

  return (
    <Grid container justify='space-evenly' >

      <IFrame />

      <Card elevation={0} className={classes.contactForm} >
        <Typography className={classes.marBot} align='center' variant='h4' color='textSecondary' >Napište nám</Typography>
        <ContactForm />
      </Card>

      <Box style={{ width: '100vw' }}>
        <ContactUs />
      </Box>

    </Grid>
  );
}

export default DateCalendar;
